import { createActionGroup, props } from '@ngrx/store';

export const TimelineSubscriptionsActions = createActionGroup({
  source: 'TimelineSubscriptions',
  events: {
    'Get Subscriptions': props<{forceReload?: boolean}>(),
    'Subscriptions loaded': props<{body: any}>(),
  }
});
